// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".emoji-rating--disabled[data-v-55141558]{position:relative}.emoji-rating--disabled[data-v-55141558]:after{background:#646464;border-radius:4px;content:\"Bewertungen sind nur für Schüler verfügbar\";left:0;padding:8px;position:absolute;top:30px;width:100%;z-index:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
